import ReturnsMobile from './ReturnsMobile';
import { withI18n } from 'react-i18next';

export default withI18n()(ReturnsMobile);
